import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import AuthService from "../services/auth.service";
import BidProfile from "../models/BidProfile";
import { Button } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import ListingService from '../services/listing.service';
import { MDBDataTable } from "mdbreact";
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import UserService from '../services/user.service';

const Profile: React.FC = () => {

  const [show, setShow] = useState(false);
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [variant, setVariant] = useState('Info')
  const [queryParams, setQueryParams ] = useSearchParams()
  const [bidProfiles, setBidProfiles] = useState([])
  
  const navigate = useNavigate()

  const retrieveDonorProfile = (uid: string) => {
    (async () => {
      try {
        let { data } = await UserService.getDonorProfile(uid)
        setBidProfiles(data.data)
      } catch (e) {

      }
    })()
  }


  useEffect(() => {
    window.scrollTo(0, 0)
    if (!AuthService.getCurrentUser()) {
      alert('You need to be logged in to view this page.')
      navigate("/login")
    } else {
        if (queryParams?.get('uid'))
          retrieveDonorProfile(queryParams.get('uid')!)
    }
  }, []);


  // const dummydata = [
  //   {
  //     orgImage:
  //       "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/International_Pok%C3%A9mon_logo.svg/1200px-International_Pok%C3%A9mon_logo.svg.png",
  //     productImage:
  //       "https://assets.pokemon.com/assets/cms2/img/pokedex/full/399.png",
  //     title: "BIDOOF",
  //     bids: 9,
  //     donated: 9999,
  //     action: "test",
  //   },
  //   {
  //     orgImage:
  //       "data:image/png;base64,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",
  //     productImage:
  //       "https://4.bp.blogspot.com/-LJNU0zovfXw/Wi70Q6Qe9QI/AAAAAAAA1Us/UAdB0bmeh4Y3WmOEoxV-RJedLJutyZvRwCLcBGAs/s1600/16f2935c13a384d4.png",
  //     title: "Dabbing Penguin",
  //     bids: 38,
  //     donated: 9999,
  //     action: "test",
  //   },
  //   {
  //     orgImage:
  //       "https://i.pinimg.com/originals/57/40/bb/5740bb4e1da387df4d92a09475c9b049.png",
  //     productImage:
  //       "https://orangemushroom.files.wordpress.com/2017/09/maplestory-256x256.png",
  //     title: "Shroom",
  //     bids: 15,
  //     donated: 9999,
  //     action: "test",
  //   },
  // ];

  const datatable = {
    columns: [
      {
        label: "Org",
        field: "orgImage",
        width: 100
      },
      {
        label: "Listing",
        field: "productImage",
        width: 100
      },
      {
        label: "Title",
        field: "title",
        width: 100
      },
      {
        label: "Bids Spent",
        field: "bids",
        width: 100,
      },
      {
        label: "Donated",
        field: "donated",
        width: 100,
      }
    ],
    rows: 
      bidProfiles.map((bp: BidProfile) => {
        return(
          {
            orgImage: <img src={bp.company_logo_url} width="48" height="48" alt={bp.company_name} />,
            productImage: <img src={bp.image} width="48" height="48" alt={bp.title} />,
            title: bp.title,
            bids: <div>{bp.bids} <img src="https://fast-content.s3.us-west-2.amazonaws.com/images/nabify_24.png" alt="bid icon" width='32' height="32" /></div>,
            donated: (<span>${bp.donated}</span>)
          }
        )
      })
      
    
  };
  
  return (
    <>
      <br />
      <br />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2>Your Donor Profile</h2>
            <p>All listings you have bid on will show up below. These amounts will refresh every 60 seconds.</p>
            <Card>
              <Card.Title>
                <p>Bid History</p>
                <hr />
              </Card.Title>
              <MDBDataTable
                btn
                searchLabel="Search product name..."
                responsive
                pagination="true"
                data={datatable}>
              </MDBDataTable>
            </Card>
          </div>
        </div>
      </div>
      <ToastContainer className="p-2" position={'top-center'}>
        <Toast bg={variant.toLowerCase()} onClose={() => setShow(false)} show={show} delay={3000} autohide>
          <Toast.Header closeButton={false}>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{title}</strong>
            <small>now</small>
          </Toast.Header>
          <Toast.Body>
            {message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
export default Profile;
